<div class="input-group d-inline-flex align-items-center">
    <input
        class="form-control input-md number-field"
        type="number"
        [value]="value() ?? ''"
        [disabled]="disabled()"
        [readOnly]="readonly()"
        [required]="required()"
        [placeholder]="placeholder()"
        [attr.min]="min()"
        [attr.max]="max()"
        [attr.step]="step()"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-invalid]="isInvalid()"
        [class.is-valid]="isValid()"
        [class.is-invalid]="isInvalid()"
        (input)="onInput($event)"
        (blur)="touched.set(true)"
    />
    @if (scannable()) {
        <button
            class="btn btn-secondary scan-button"
            type="button"
            [disabled]="readonly() || disabled()"
            [attr.aria-label]="'BARCODE_SCANNER_SET_TITLE' | translate"
            (click)="scan()"
        >
            <fa-icon [icon]="faBarcode" size="2x"></fa-icon>
        </button>
    }
    @if (unit()) {
        <span class="input-group-text">{{ unit() }}</span>
    }
</div>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
